import React from 'react';
import { Link } from 'gatorcomponents';

export default {
  startModal: {
    title: 'Definir tu dominio propio',
    description: () => (
      <>
        Tu plan actual está utilizando un dominio temporal, y para crear una cuenta de correo electrónico, necesitas un dominio propio.
        <br />
        <br />
        <b>Consejo:</b>
        {' '}
        El dominio es la dirección de tu sitio web en internet, y puede ser el nombre de tu empresa o marca.
      </>
    ),
    buttonLabel: 'Definir dominio',
  },
  startModalFreeDomain: {
    title: 'Resgate seu domínio gratuito',
    description: recoverFreeDomainTld => (
      <>
        Antes de crear tu cuenta de correo electrónico, canjea tu dominio gratuito.
        <br />
        Puedes elegir entre las extensiones
        {' '}
        {recoverFreeDomainTld.join(', ')}
        .
        <br />
        <br />
        <b>Atención:</b>
        {' '}
        el canje puede realizarse hasta 90 días después de contratar tu plan de correo electrónico.
      </>
    ),
    buttonLabel: 'Resgatar domínio gratuito',
  },
  changeDomainPage: {
    breadcrumbs: {
      email: 'Correos',
      changeDomain: 'Definir dominio',
      buyDomain: 'Comprar dominio',
    },
    loadingLabel: '¡Falta poco! No cierres esta ventana... ',
    inputPage: {
      title: '¿Qué dominio quieres usar en tu plan de correo electrónico?',
      description: 'Elige o crea un dominio que se usará para crear tus cuentas de correo electrónico.',
      inputPlaceholder: 'Ingresa tu dominio completo (ej.: midominio.com.cl)',
      inputPlaceholderMobile: 'ej.: midominio.com.br',
      alertDescription: domain => (
        <>
          {'El nuevo dominio reemplazará al actual '}
          <Link text={domain} href={`http://${domain}`} target="_blank" decoration />
          <br />
          <br />
          El correo electrónico estará indisponible hasta que se complete todo el proceso.
        </>
      ),
      buttonBackLabel: 'Volver',
      buttonContinueLabel: 'Continuar',
      error: {
        message: 'Verifica la información e inténtalo de nuevo.',
        title: 'Algo salió mal.',
      },
    },
    notRegistered: {
      title: domain => (
        <>
          {'El dominio "'}
          {domain}
          {'" está disponible para su compra'}
        </>
      ),
      description: 'Ha llegado el momento de comprar tu dominio para tener tu cuenta de correo profesional. Luego, solo tienes que regresar a la sección de correo Titan y finalizar la configuración.',
      buttonContinueLabel: 'Comprar dominio',
      buttonBackLabel: 'Volver',
    },
    buyingDomain: {
      title: '¡Excelente elección! Estás comprando un nuevo dominio.',
      description: 'Una vez completada la compra, regresa al Panel del Cliente en Correos y finaliza la configuración de los registros DNS.',
      helpLabel: (
        <>
          {'En caso de dudas, '}
          <Link
            text="accede al material sobre cómo configurar el DNS."
            target="_blank"
            href="https://suporte.hostgator.com.br/hc/pt-br/articles/30810621770387-Como-configurar-o-dom%C3%ADnio-alterar-DNS"
          />
        </>
      ),
      buttonLabel: 'Volver a Correos',
    },
    notAvailableInTitan: {
      title: domain => (
        <>
          {'El dominio "'}
          {domain}
          {'" no está disponible'}
        </>
      ),
      description: 'Este dominio ya está siendo usado por una cuenta de Titan. Elige o crea otro dominio.',
      buttonLabel: 'Probar con otro dominio ',
    },
    internalDomain: {
      title: domain => (
        <>
          {'El dominio "'}
          {domain}
          {'" está registrado con nosotros'}
        </>
      ),
      description: 'Ahora vamos configurar tu dominio y dejarlo listo para que puedas crear tu cuenta.',
      checkBoxLabel: 'Confirmo que quiero usar este dominio y que no será posible cambiarlo después.',
      backButtonLabel: 'Volver',
      continueButtonLabel: 'Configurar dominio',
    },
    externalDomain: {
      title: domain => (
        <>
          {'El dominio "'}
          {domain}
          {'" está registrado en otra empresa'}
        </>
      ),
      description: 'Por eso, necesitas conectar tu dominio a nuestro correo Titan agregando los registros DNS (la dirección de tu dominio).',
      advise: 'Para hacerlo, serás dirigido a la gestión de correo en el Panel del Cliente. Sigue las instrucciones que aparecerán en la pantalla. Si necesitas ayuda, habla con nuestra Inteligencia Artificial en la parte superior de la página.',
      checkBoxLabel: 'Confirmo que quiero usar este dominio y que no será posible cambiarlo después.',
      backButtonLabel: 'Volver',
      continueButtonLabel: 'Configurar ahora',
    },
    changedInternalTitanDomain: {
      title: '¡Listo! La configuración del dominio se ha completado',
      description: 'Ya puedes crear tu cuenta de correo electrónico. Pero para enviar correos, es necesario esperar hasta 2 horas para que la dirección funcione correctamente en internet.',
      buttonLabel: 'Crear cuenta de correo',
    },
    changeDomainFail: {
      title: 'No se pudo completar la configuración de tu dominio.',
      description: 'Espera un momento e intenta nuevamente más tarde.',
      buttonLabel: 'Volver a Correos',
    },
  },
};
